import {
  AirlineLiteModel,
  AirlineModel,
  getAirlineKey,
  getAirlinesKey,
  useGetAirline,
  useGetAirlines,
} from 'api-hooks/airline';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { ModelTransformer } from 'common/helpers/common';
import { transformLabel } from 'common/utils/string';
import { ColumnDataType } from 'components/elements/table/type';
import React from 'react';

import useGetCrudPermission from './use-get-crud-permission';
import useNavigation from './use-navigation';

export function airlineTransformer(
  item: AirlineLiteModel | AirlineModel,
): Option {
  return {
    id: item.id,
    label: transformLabel([item.code, item.name]),
    item,
  };
}

export default function useGetAirlineColumn() {
  const { navigate } = useNavigation();
  const permission = useGetCrudPermission('airlines');
  return React.useMemo(() => {
    return {
      dataType: ColumnDataType.select,
      useListQueryHook: useGetAirlines,
      useDetailLazyQueryHook: useGetAirline,
      listKeyFunction: getAirlinesKey,
      detailKeyFunction: getAirlineKey,
      getMemoizedListVariables: (page, q) => ({
        params: {
          q,
          page,
        },
      }),
      getMemoizedDetailVariables: (value: string) => ({
        id: value,
      }),
      listTransformer: (result) => {
        return result.data.map((v) => {
          const data = ModelTransformer(v, AirlineLiteModel);
          return airlineTransformer(data);
        });
      },
      detailTransformer: (result) => {
        const data = ModelTransformer(result.data, AirlineModel);
        return airlineTransformer(data);
      },
      paginationTransformer: (result) => {
        return result.meta;
      },

      renderCreate: permission.create,
      onClickCreate: () => {
        navigate(NavigationRoutes.AirlinesCreate);
      },
    };
  }, [navigate, permission.create]);
}
